import { Reveal } from "../Reveal";

export const ChiSono = () => (
  <section
    id="chi-sono"
    data-testid="chi-sono-section"
    className="relative mx-auto max-w-7xl px-6 py-28 md:px-14 md:py-40"
  >
    <div className="grid grid-cols-12 gap-8 md:gap-12">
      <div className="col-span-12 md:col-span-4">
        <Reveal>
          <div className="flex items-baseline gap-4">
            <span className="font-display text-2xl italic text-[#c0442b]">01</span>
            <span className="overline">Chi sono</span>
          </div>
        </Reveal>

        {/* Portrait — editorial black & white */}
        <Reveal delay={0.15}>
          <div
            data-testid="portrait"
            className="mt-10 aspect-[3/4] w-full overflow-hidden border border-[#16181a]/25 bg-[#16181a]"
          >
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_direzione-creativa/artifacts/dhqm9cud_486255318_10232874997970128_9047834517649822839_n.webp"
              alt="Ritratto di Gianni Ragone"
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        </Reveal>
      </div>

      <div className="col-span-12 md:col-span-8 md:pl-10">
        <Reveal>
          <h2 className="font-display text-4xl font-light leading-[1.05] tracking-tight text-[#16181a] md:text-6xl">
            Metto in dialogo{" "}
            <span className="italic text-[#c0442b]">creatività</span> e obiettivi di comunicazione.
          </h2>
        </Reveal>

        <div className="mt-10 space-y-6 md:mt-14 md:space-y-7">
          <Reveal delay={0.1}>
            <p className="max-w-2xl font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
              Lavoro come Direttore Creativo occupandomi di grafica pubblicitaria, produzioni video
              e social media marketing. Sono tre linguaggi diversi che, per me, appartengono a un
              unico gesto: costruire comunicazione che abbia senso e forma insieme.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-2xl font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
              Ogni progetto parte da una domanda semplice — cosa deve capire chi guarda? — e da lì
              cerco l'equilibrio tra idea, immagine e parola. Non credo alla creatività fine a sé
              stessa: credo a quella che tiene insieme identità, contesto e obiettivi.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-2xl font-body text-base leading-relaxed text-[#2a2b2d] md:text-lg">
              La complementarità tra grafica, video e social è la parte del mio lavoro a cui tengo
              di più: mi permette di seguire un progetto con lo stesso sguardo dall'inizio alla
              fine, evitando che i pezzi vadano in direzioni diverse.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="mt-14 flex flex-wrap gap-2">
            {["Direzione creativa", "Grafica pubblicitaria", "Produzioni video", "Social media"].map((t) => (
              <span
                key={t}
                className="border border-[#16181a]/25 px-4 py-2 font-body text-xs uppercase tracking-widest text-[#2a2b2d]"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
